import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Hidden,
  Paper,
} from '@material-ui/core'

import CONFIG from '../../config'
import axios from '../../utils/api'
import { login, getErrorText } from '../../utils/AuthService'
import Layout from './Layout'
import EmailView from './EmailView'
import PasswordView from './PasswordView'
import ErrorView from './ErrorView'
import LearnMoreCard from './LearnMoreCard'

const DEFAULT_STATE = {
  email: '',
  error: null,
}

class Login extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    promptItem: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: 'auto',
      },
    },
    promptPaper: {
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3),
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '520px',
        padding: theme.spacing(5),
      },
    },
  })

  state = DEFAULT_STATE

  handleError = (err) => {
    this.setState({
      error: {
        text: getErrorText(err),
        subtext: 'If you are having trouble accessing your Bloksense account, check that you typed your email address correctly.',
      },
    })
  }

  handleEmail = (email) => {
    axios
      .post(`${CONFIG.apiBase}/auth_email_check`, { email })
      .then(
        (response) => {
          this.setState({ email: response.data.body.email })
        },
        (error) => {
          const errorCode = (error.response.data.body && error.response.data.body.error) || ''
          let text = 'An Error has occurred.'
          let subtext = 'If you are having trouble accessing your Bloksense account, check that you typed your email address correctly.'
          switch (errorCode) {
            case 'DOMAIN_UNAUTHORIZED':
              text = 'It doesn\'t look like your organization is using BlokSense yet.'
              break
            case 'DOMAIN_OK_USER_DNE':
              text = 'Your organization is using BlokSense but you don\'t have access. Please contact your BlokSense Administrator.'
              subtext = ''
              break
            default:
              break
          }
          this.setState({
            error: {
              text,
              subtext,
            },
          })
        },
      )
  }

  handleSignIn = (password) => {
    login(this.state.email, password, this.handleError)
  }

  handleRestart = () => {
    this.setState(DEFAULT_STATE)
  }

  renderPrompt = () => {
    const { email, error } = this.state

    if (error) {
      return <ErrorView error={error} onRestart={this.handleRestart} />
    }

    if (email === '') {
      return <EmailView onSubmit={this.handleEmail} />
    }

    return <PasswordView onSubmit={this.handleSignIn} email={email} />
  }

  renderMiniLearnMore = () => {
    const { classes } = this.props
    const { email, error } = this.state

    // Show it:
    // - only with the EmailView, and
    // - only below the md breakpoint
    if (email === '' && !error) {
      return (
        <Hidden mdUp>
          <Grid item className={classes.promptItem}>
            <LearnMoreCard isMini />
          </Grid>
        </Hidden>
      )
    }

    return null
  }

  render() {
    const { classes } = this.props

    return (
      <Layout>
        <Grid item className={classes.promptItem}>
          <Paper elevation={3} square classes={{ root: classes.promptPaper }}>
            { this.renderPrompt() }
          </Paper>
        </Grid>
        { this.renderMiniLearnMore() }
      </Layout>
    )
  }
}

export default withStyles(Login.styles)(Login)
